import React from "react";
import styled from "styled-components";

import { PickedWorkspaceUser, WorkspaceWithLicense } from "@examspark/api";
import { Button, Callout, Toolbar, VSpace } from "@examspark/common-ui";
import { IconImageLine } from "@examspark/common-ui/dist/components/icons";

import { useAppContext } from "../../providers";
import NoResults from "../NoResults";

const StyledButtons = styled.div`
  max-height: 50vh;
  overflow: auto;

  & button {
    font-size: 10px;
  }
`;

const StyledWorkspaceApp = styled.div`
  border: solid 1px #ddd;
  border-radius: 0.5rem;
  padding: 0.7rem;
  cursor: pointer;
  transition: border-color 0.2s ease-in-out;

  &:hover {
    border: solid 1px #aaa;
  }
`;
const StyledWorkspaceAppName = styled.div`
  font-weight: bold;
  font-size: 1.4rem;
`;
const StyledWorkspaceAppId = styled.div`
  font-size: 1rem;
  color: #777;
`;
const StyledIcon = styled.div`
  font-size: 1rem;
  color: #777;
  height: 36px;
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f2f2f2;

  svg {
    display: block;
    fill: #777;
  }
`;

const StyledToolbar = styled(Toolbar)`
  gap: 1rem;
`;

const LoginCampfireNeoApps = (props: {
  options?: PickedWorkspaceUser[];
  onBack?: () => void;
  onRegister?: () => void;
  onSelect?: (workspace: WorkspaceWithLicense) => void;
}) => {
  const [state] = useAppContext();

  return (
    <VSpace style={{ gap: "2rem" }}>
      {props.options?.length === 0 ? (
        <NoResults>You have no registered applications.</NoResults>
      ) : (
        <Callout>Select an application to launch</Callout>
      )}
      <StyledButtons>
        <VSpace size={"0.5rem"}>
          {props.options?.map((o) => (
            <React.Fragment key={o.id}>
              {o.appLicenses?.map((l) => (
                <StyledWorkspaceApp
                  title=""
                  key={`${o.id}-${l.appId}`}
                  onClick={() => {
                    props.onSelect?.({
                      ...o,
                      appLicense: l,
                    });
                  }}
                >
                  <StyledToolbar>
                    <StyledIcon>
                      <IconImageLine width="24" />
                    </StyledIcon>
                    <Toolbar.Flex>
                      <StyledWorkspaceAppName>{o.name}</StyledWorkspaceAppName>
                      <StyledWorkspaceAppId>
                        {l.app?.name} ({l.appId})
                      </StyledWorkspaceAppId>
                    </Toolbar.Flex>
                  </StyledToolbar>
                </StyledWorkspaceApp>
              ))}
            </React.Fragment>
          ))}
        </VSpace>
      </StyledButtons>
      {state.sso ? (
        <Button
          title="Register"
          variant="contained"
          stretch
          onClick={props.onRegister}
        >
          Register
        </Button>
      ) : (
        <Button
          title="Go Back"
          variant="contained"
          stretch
          onClick={props.onBack}
          // isLoading={isLoggingIn}
        >
          Go Back
        </Button>
      )}
    </VSpace>
  );
};

export default LoginCampfireNeoApps;
